<template>
    <div class="form">
        <a-card size="small" :title="pageTitle">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-spin :spinning="formLoading">
                <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                    :wrapper-col="wrapperCol">

                    <p class="form_title">资源管理</p>
                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="cpu" label="CPU" prop="cpu">
                                <a-radio-group type="primary" v-model="record.cpu">
                                    <a-radio-button value="2">双核</a-radio-button>
                                    <a-radio-button value="4">四核</a-radio-button>
                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-model-item ref="memory" label="内存" prop="memory">
                                <a-radio-group v-model="record.memory">
                                    <a-radio-button value="8">8G</a-radio-button>
                                    <a-radio-button value="16">16G</a-radio-button>
                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-model-item ref="memorycount" label="内存条数" prop="memorycount">
                                <a-input-number v-model="record.memorycount" :min="1" :max="99999999999"></a-input-number>
                            </a-form-model-item>
                        </a-col>

                        
                    </a-row>

                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="flow" label="带宽" prop="flow">
                                <a-select v-model="record.flow" placeholder="" style="width: 80px">
                                    <a-select-option value="10M"> 10M </a-select-option>
                                    <a-select-option value="20M"> 20M </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-model-item ref="ossflag" label="OSS" prop="ossflag">
                                <a-switch v-model="record.ossflag" />
                            </a-form-model-item>
                        </a-col>
                        
                    </a-row>

                    <p class="form_title">中间件</p>
                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="mseflag" label="MSE" prop="mseflag">
                                <a-switch v-model="record.mseflag" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item ref="msenum" label="MSE数量" prop="msenum">
                                <a-input-number v-model="record.msenum" :min="1" :max="99999999999"></a-input-number>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item ref="dbtype" label="DB类型" prop="dbtype">
                                <a-select v-model="record.dbtype" style="width: 100px">
                                    <a-select-option value="PolarDB">PolarDB</a-select-option>
                                    <a-select-option value="Mysql">Mysql</a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item ref="dbnum" label="DB数量" prop="dbnum">
                                <a-input-number v-model="record.dbnum" :min="1" :max="99999999999"></a-input-number>
                            </a-form-model-item>
                        </a-col>

                    </a-row>
                    

                    <p class="form_title">网络加速及网络安全</p>
                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="dnsflag" label="DNS" prop="dnsflag">
                                <a-switch v-model="record.dnsflag" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item ref="cdnflag" label="CDN" prop="cdnflag">
                                <a-switch v-model="record.cdnflag" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item ref="wafflag" label="WAF" prop="wafflag">
                                <a-switch v-model="record.wafflag" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <p class="form_title">监控</p>
                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="slsflag" label="日志采集" prop="slsflag">
                                <a-switch v-model="record.slsflag" />
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-model-item ref="cloudmonitor" label="云监控" prop="cloudmonitor">
                                <a-switch v-model="record.cloudmonitor" />
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="6">
                            <a-form-model-item ref="ackflag" label="容器管理" prop="ackflag">
                                <a-switch v-model="record.ackflag" />
                            </a-form-model-item>
                        </a-col>

                    </a-row>

                    <p class="form_title">中仑短信服务</p>
                    <a-row>
                        <a-col :span="6">
                            <a-form-model-item ref="smsflag" label="短信服务" prop="smsflag">
                                <a-switch v-model="record.smsflag" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    

                    <a-form-model-item :wrapper-col="{ span: 8, offset: 10 }">
                        <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                            保存
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="handleCancel">
                            取消
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-spin>
        </a-card>
    </div>

</template>
<script>

export default {
    data() {
        return {
            is_new:false,
            formLoading:true,
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            kaenv:'',
            kadesc:'',
            pageTitle:'',
            rules: {
                syscode: [
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'inline',
            record:{
                ackflag: true,
                cdnflag: true,
                cloudmonitor: true,
                dbnum: 3,
                dbtype: "Mysql",
                dnsflag: true,
                cpu:'2',
                memory:'8',
                memorycount:2,
                ecsnum: "2C8G*2",
                flow: "20M",
                mseflag: true,
                msenum: 2,
                ossflag: true,
                slsflag: true,
                smsflag: true,
                wafflag: true
            }
        };
    },
    components:{
    },
    methods: {
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    let tempRecord = {
                        kaenv:that.kaenv,
                        ackflag: that.record.ackflag ? '1' : '0',
                        cdnflag: that.record.cdnflag ? '1' : '0',
                        cloudmonitor: that.record.cloudmonitor ? '1' : '0',
                        dbnum: that.record.dbnum,
                        dbtype: that.record.dbtype,
                        dnsflag: that.record.dnsflag ? '1' : '0',
                        ecsnum: that.record.cpu + 'C' + that.record.memory+'G*'+that.record.memorycount,
                        flow: that.record.flow,
                        mseflag: that.record.mseflag ? '1' : '0',
                        msenum: that.record.msenum,
                        ossflag: that.record.ossflag ? '1' : '0',
                        slsflag: that.record.slsflag ? '1' : '0',
                        smsflag: that.record.smsflag ? '1' : '0',
                        wafflag: that.record.wafflag ? '1' : '0'
                    }
                    if(!that.is_new){
                        that.$store
                            .dispatch({
                                type: "kamanager/updateres",
                                params: tempRecord
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else{
                        //新增
                        that.$store
                            .dispatch({
                                type: "kamanager/addres",
                                params: tempRecord
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(){
            let that = this;
            that.formLoading = true;
            this.$store.dispatch({
                type: "kamanager/queryres",
                params: {
                    kaenv:this.kaenv,
                },
                showMsg: false
            }).then((res) => {
                setTimeout(function(){
                    that.formLoading = false;
                },200);
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.is_new = JSON.stringify(result) == '{}';
                    that.pageTitle = that.kadesc + ' - ' + (that.is_new ? '新增' : '修改') + '资源配置'
                    if(!that.is_new){
                        that.record = {
                            ackflag: result.ackflag == 1,
                            cdnflag: result.cdnflag == 1,
                            cloudmonitor: result.cloudmonitor == 1,
                            dbnum: result.dbnum,
                            dbtype: result.dbtype,
                            dnsflag: result.dnsflag == 1,
                            ecsnum: result.ecsnum,
                            cpu:result.ecsnum.split('C')[0],
                            memory:result.ecsnum.split('C')[1].split('G')[0],
                            memorycount:result.ecsnum.split('C')[1].split('G')[1].split('*')[1],
                            flow: result.flow,
                            mseflag: result.mseflag == 1,
                            msenum: result.msenum,
                            ossflag: result.ossflag == 1,
                            slsflag: result.slsflag == 1,
                            smsflag: result.smsflag == 1,
                            wafflag: result.wafflag == 1
                        }
                    }
                   
                    
                }
            });
        }
    },

    mounted(){
        const { query } = this.$route;
        this.kaenv = query.kaenv;
        this.kadesc = query.kadesc;
        //调用查询接口决定是编辑还是新增
        this.getDetail()

    }
};
</script>

<style scoped>
.myForm{
    max-width: 800px;
}
.ant-form-item{
    display: flex;
    padding: 4px 0;
}
.form_title{
    background-color: #eff3f6;
    padding: 10px;
    margin-top: 10px;
}
</style>
